import { Button, Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useHasPermission } from '@/entities/profile';
import { SaveButton } from '@/shared/ui';

type Props = {
  title: string;
  /** Есть ли в форме несохранённые изменения — от него зависит индикация */
  isDirty: boolean;
  onSave: () => void;
  onReset: () => void;
  isSaving?: boolean;
  children: ReactNode;
};

export const ConfigFormLayout: FC<Props> = ({ title, isDirty, onSave, onReset, isSaving, children }) => {
  const { t } = useTranslation('anonymizerConfig');
  const canEdit = useHasPermission('ADMIN_ANONYMIZE_CONFIG');

  return (
    <Card className="h-full flex flex-col overflow-hidden">
      <CardHeader className="flex items-center justify-between gap-4 shrink-0">
        <CardTitle>{title}</CardTitle>
        {canEdit && (
          <SaveButton
            isDirty={isDirty}
            isLoading={isSaving}
            onClick={onSave}
            secondaryAction={
              <Button variant="outline" onClick={onReset}>
                {t('reset')}
              </Button>
            }
          />
        )}
      </CardHeader>
      <CardContent className="flex-1 overflow-auto">{children}</CardContent>
    </Card>
  );
};
